'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ----------------------------------------------------------------------- Imports


// import { flow as compose } from 'lodash';

// ----------------------------------------------------------------------- Style

// ----------------------------------------------------------------------- Component
/**
  * Header
  */
var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  /**
    * constructor - Just a standard constructor.
    */
  function Header(props) {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _React$Component.call(this, props));
  }

  /**
    * render - Standard renderer.
    */


  Header.prototype.render = function render() {
    return _react2.default.createElement(
      'header',
      this.props,
      this.props.children
    );
  };

  return Header;
}(_react2.default.Component);

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
  // style: PropTypes.object, // eslint-disable-line
  // className: PropTypes.string, // eslint-disable-line
  // unset: PropTypes.bool,
  // classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

Header.defaultProps = {
  // style: {},
  // unset: false,
};

// ----------------------------------------------------------------------- Compose Component
/**
  * ComposedComponent - Compose component ala FP style.
  */
// const ComposedComponent = compose([

// ])(Header);

// ----------------------------------------------------------------------- Export
exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/semantic-webflow/lib/Header.js
// module id = 446
// module chunks = 168707334958949